const list = `[List] `;

export const FETCH_LIST = `${list} FETCH LIST`;
export const FETCH_CAT = `${list} FETCH CAT`;
export const SET_SUBCAT = `${list} SET SUBCAT`;
export const SET_LIST = `${list} SET LIST`;
export const UPDATE_COUNT = `${list} UPDATE COUNT`;
export const UPDATE_SETTINGS = `${list} UPDATE SETTINGS`;
export const FILTER_SUBCAT = `${list} FILTER SUBCAT`;
export const REST_SUBCAT = `${list} RESET SUBCAT`;
export const FETCH_OVERLAY = `${list} FETCH OVERLAY`;
export const FETCH_TEMPLATE = `${list} FETCH TEMPLATE`;
export const ACTIVE_PAGE = `${list} ACTIVE PAGE`;
export const SET_NAVLINK = `${list} SET NAVLINK`;
export const SET_TEMPLATE = `${list} SET TEMPLATE`;
export const UPDATE_HEADING = `${list} UPDATE HEADING`;
export const UPDATE_SEARCH = `${list} UPDATE SEARCH`;
